// src/components/DeepLinks/DeepLinkRedirects.js
import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { isTelegramWebApp } from '../../utils/deepLinkUtils';

// Component to handle chain redirect for users without wallets
export const ChainParamRedirect = () => {
  const { chainKey } = useParams();
  const isTelegram = isTelegramWebApp();
  
  // Store param in sessionStorage before redirecting
  useEffect(() => {
    if (chainKey) {
      console.log(`Storing chain key ${chainKey} in sessionStorage before redirect${isTelegram ? ' (Telegram)' : ''}`);
      sessionStorage.setItem('deep_link_chain', chainKey);
    }
  }, [chainKey, isTelegram]);
  
  // Redirect to welcome page with params already stored in sessionStorage
  return <Navigate to="/" replace />;
};

// Component to handle chain+token redirect for users without wallets
export const TokenParamRedirect = () => {
  const { chainKey, tokenAddress } = useParams();
  const isTelegram = isTelegramWebApp();
  
  // Store params in sessionStorage before redirecting
  useEffect(() => {
    if (chainKey) {
      console.log(`Storing chain key ${chainKey} in sessionStorage before redirect${isTelegram ? ' (Telegram)' : ''}`);
      sessionStorage.setItem('deep_link_chain', chainKey);
    }
    
    if (tokenAddress) {
      console.log(`Storing token address ${tokenAddress} in sessionStorage before redirect${isTelegram ? ' (Telegram)' : ''}`);
      // We use a minimal object with just what we need
      const tokenData = JSON.stringify({
        token: { address: tokenAddress },
        action: 'buy'
      });
      sessionStorage.setItem('deep_link_swap_token', tokenData);
    }
  }, [chainKey, tokenAddress, isTelegram]);
  
  // Redirect to welcome page with params already stored in sessionStorage
  return <Navigate to="/" replace />;
};